import { Box, Button, Grid, Tooltip, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedCheckboxRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import HelpIcon from '@mui/icons-material/Help';

interface IManageEmployeesInfoSetupFieldsPanel {
	employeeDDL: any;
	linkedEmployeesDDL: any;
	onExportEmployeesClickedHandler: () => void;
	onImportEmployeesClickedHandler: () => void;
	importDataPageName: string;
}
export const ManageEmployeesInfoSetupFieldsPanel: FC<
	IManageEmployeesInfoSetupFieldsPanel
> = ({ employeeDDL, linkedEmployeesDDL, onExportEmployeesClickedHandler, onImportEmployeesClickedHandler, importDataPageName }) => {
	const theme = useTheme();
	const [openTooltip, setOpenTooltip] = useState(false);

	const handleToggle = () => {
		setOpenTooltip((prev) => !prev);
	};
	const tooltipContent = (
		<Box sx={{ p: 1.5, minWidth: 220 }}>
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="center"
			>
				<Typography fontWeight="bold">
					Employee(s)
				</Typography>
				<EnhancedButtonPrimeReact
					icon="pi pi-times"
					onClickHandler={() => setOpenTooltip(false)}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
					rounded
				/>
			</Box>

			{employeeDDL && employeeDDL.map((item: any, index: number) => {
				return (
					<Box key={index}>
						<Typography>
							{index + 1}. {item.label}
						</Typography>
					</Box>
				);
			})}
			<Box
				display="flex"
				justifyContent="center"
				mt={1}
			>
				<span style={{ color: theme.palette.primary.light, cursor: "pointer", fontSize: ".875rem" }} onClick={() => setOpenTooltip(false)}>Close</span>
			</Box>
		</Box>
	);

	return (
		<>
			{importDataPageName !== "zoho_people" && <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<Tooltip
					title={tooltipContent}
					placement="bottom-start"
					open={openTooltip}
					onClose={() => setOpenTooltip(false)}
					disableHoverListener
					disableFocusListener
					disableTouchListener
					slotProps={{
						popper: {
							modifiers: [
								{
									name: "offset",
									options: {
										offset: [-15, -30], // remove the gap
									},
								},
							],
						},
						tooltip: {
							sx: {
								bgcolor: "white",
								color: "black",
								boxShadow: 3,
								borderRadius: 2,
							}
						}
					}}>
					<Typography style={{ fontSize: ".875rem", paddingBottom: "1rem" }}>
						{/* <span style={{ color: theme.palette.primary.light, cursor: "pointer", }} onClick={handleToggle}>{employeeDDL && employeeDDL.length} employees</span> {` created but not exported to When I Work.`} */}
						<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={handleToggle}>
							{employeeDDL && employeeDDL.length} employees
						</span>{" "}
						{importDataPageName === "namely"
							? `created but not exported to Namely.`
							: importDataPageName === "bamboo_hr"
								? `created but not exported to BambooHR.`
								: `created but not exported to When I Work.`}
					</Typography>
				</Tooltip>
				<EnhancedButtonPrimeReact
					label="Export Employee(s)"
					// type="submit"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					onClickHandler={onExportEmployeesClickedHandler}
				/>
			</Grid>}

			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Typography style={{ fontSize: ".875rem", padding: "1rem 0rem" }}>
					{importDataPageName === "when_i_work" ? `Import ${linkedEmployeesDDL && linkedEmployeesDDL.length} employees data from When I Work to SimplePay.` : importDataPageName === "bamboo_hr" ? `Import Import employee(s) data from BambooHR` :  importDataPageName === "namely" ? `Import employee(s) data from Namely` : `Import ${linkedEmployeesDDL && linkedEmployeesDDL.length} employees data from Zoho People to SimplePay.`}
				</Typography>
				<EnhancedButtonPrimeReact
					label="Import Employee(s)"
					// type="submit"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					onClickHandler={onImportEmployeesClickedHandler}
				/>
			</Grid>
		</>
	);
};
